export default class EmailAddedEvent {

    constructor(type, conversation, addedItem) {
        this.type = type;
        this.conversation = conversation;
        this.addedItem = addedItem;
    };    
}

EmailAddedEvent.EMAIL_ADDED_TO_CONVERSATION = "EmailAddedEvent.EMAIL_ADDED_TO_CONVERSATION";